import React, { useRef } from 'react';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ProductCard from './ProductCard';
import { Button } from './ui/button';

export const CategorySection = ({ categoryName, products }) => {
    const navigate = useNavigate();
    const scrollContainerRef = useRef(null);

    const handleViewAll = () => {
        navigate(`/category/${encodeURIComponent(categoryName)}`);
    };

    const scroll = (direction) => {
        if (scrollContainerRef.current) {
            const scrollAmount = 300;
            const newScrollLeft = scrollContainerRef.current.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount);
            scrollContainerRef.current.scrollTo({
                left: newScrollLeft,
                behavior: 'smooth'
            });
        }
    };

    if (!products || products.length === 0) {
        return null;
    }

    return (
        <div className="mb-8">
            {/* Section Header */}
            <div className="flex items-center justify-between mb-4">
                <h2 className="font-heading text-lg md:text-xl font-bold text-gray-900">
                    {categoryName}
                </h2>
                <Button
                    variant="ghost"
                    onClick={handleViewAll}
                    className="text-[#0052CC] hover:bg-[#0052CC]/10 text-sm font-semibold"
                >
                    Lihat Semua
                    <ChevronRight className="w-4 h-4 ml-1" />
                </Button>
            </div>

            {/* Horizontal Scroll Container */}
            <div className="relative group">
                {/* Left Scroll Button */}
                <button
                    onClick={() => scroll('left')}
                    className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/90 hover:bg-white shadow-lg rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                    aria-label="Scroll left"
                >
                    <ChevronLeft className="w-5 h-5 text-gray-700" />
                </button>

                {/* Right Scroll Button */}
                <button
                    onClick={() => scroll('right')}
                    className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/90 hover:bg-white shadow-lg rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                    aria-label="Scroll right"
                >
                    <ChevronRight className="w-5 h-5 text-gray-700" />
                </button>

                {/* Products Scroll Container */}
                <div
                    ref={scrollContainerRef}
                    className="flex gap-4 overflow-x-auto scrollbar-hide scroll-smooth pb-2"
                    style={{
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                    }}
                >
                    {products.map((product, index) => (
                        <div key={`${product.product_id}-${index}`} className="flex-shrink-0 w-[160px] sm:w-[180px]">
                            <ProductCard
                                product={product}
                                merchant={product.merchant}
                            />
                        </div>
                    ))}
                </div>
            </div>

            <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
        </div>
    );
};

export default CategorySection;
